import { classNames } from 'libs/react';
import { React } from 'libs/react';
import './FormPanel.scss';
/**
 * @component FormPanel
 * @since 1.0.0
 */
export function FormPanel(props) {
    const { style, ratio } = Object.assign({ style: 'normal', ratio: 0 }, props);
    const className = classNames('form-panel', 'form-panel--' + style, 'form-panel--' + ratio, props.className);
    return React.createElement("div", { className: className }, props.children);
}
